import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M10.79 16.29C11.18 16.68 11.81 16.68 12.2 16.29L15.79 12.7C16.18 12.31 16.18 11.68 15.79 11.29L12.2 7.7C11.81 7.31 11.18 7.31 10.79 7.7C10.4 8.09 10.4 8.72 10.79 9.11L12.67 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H12.67L10.79 14.88C10.4 15.27 10.41 15.91 10.79 16.29ZM19 3H5C3.89 3 3 3.9 3 5V8C3 8.55 3.45 9 4 9C4.55 9 5 8.55 5 8V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V16C5 15.45 4.55 15 4 15C3.45 15 3 15.45 3 16V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.50006 1.93506C3.63573 1.93506 2.93506 2.63573 2.93506 3.50006V4.77279C2.93506 5.08483 3.18802 5.33779 3.50006 5.33779C3.8121 5.33779 4.06506 5.08483 4.06506 4.77279V3.50006C4.06506 3.25981 4.25981 3.06506 4.50006 3.06506H12.5001C12.7403 3.06506 12.9351 3.25981 12.9351 3.50006V11.5001C12.9351 11.7403 12.7403 11.9351 12.5001 11.9351H4.50006C4.25981 11.9351 4.06506 11.7403 4.06506 11.5001V10.2273C4.06506 9.91529 3.8121 9.66233 3.50006 9.66233C3.18802 9.66233 2.93506 9.91529 2.93506 10.2273V11.5001C2.93506 12.3644 3.63573 13.0651 4.50006 13.0651H12.5001C13.3644 13.0651 14.0651 12.3644 14.0651 11.5001V3.50006C14.0651 2.63573 13.3644 1.93506 12.5001 1.93506H4.50006ZM3.50006 6.93494C3.18802 6.93494 2.93506 7.1879 2.93506 7.49994C2.93506 7.81198 3.18802 8.06494 3.50006 8.06494H8.13603L7.10054 9.10043C6.8799 9.32107 6.8799 9.67881 7.10054 9.89946C7.32119 10.1201 7.67893 10.1201 7.89957 9.89946L9.89957 7.89946C10.1202 7.67881 10.1202 7.32107 9.89957 7.10043L7.89957 5.10043C7.67893 4.87978 7.32119 4.87978 7.10054 5.10043C6.8799 5.32107 6.8799 5.67881 7.10054 5.89946L8.13603 6.93494H3.50006Z"
  />
);

export const ExitIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Exit" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
